/* eslint-disable */
<script>
export default {
  /*props: {
      'statusMessages': {
        default () {
          return {
            show: false,
            status: null,
            message: null,
            type: null
          }
        }
      }
    },*/
  methods: {
    defaultErrorHandler(error) {
      this.$alert(error.response.data.message, error.message, {
        type: "error",
      });
    },
  },
};
</script>
